import type { IIconProps } from '@app/components/Icon/types'
import { PldIcon } from '@tenable/paladin'
import type React from 'react'

interface IIconSettingProps extends IIconProps {}

const IconSetting: React.FC<IIconSettingProps> = props => {
  return (
    <tenable-floating-button
      id="settings-menu-button"
      aria-label="Settings"
      aria-haspopup="true"
    >
      <PldIcon icon="IconSettings" size="iconSizeM" color="colorTextPrimary" />
    </tenable-floating-button>
  )
}

export default IconSetting
